<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

function defaultQrJson() {
  return {
    x: 6,
    y: 6,
    height: 28,
    width: 28,
    value: "12345678",
    codeType: 31,
    rotate: 270,
  };
}

function defaultTextJson() {
  return {
    x: 32,
    y: 15,
    height: 10,
    width: 40,
    value: "label_text",
    fontFamily: "鸿蒙",
    rotate: 270,
    fontSize: 7,
    textAlignHorizonral: 1,
    textAlignVertical: 1,
    letterSpacing: 0,
    lineSpacing: 1,
    lineMode: 6,
    fontStyle: [true, false, false, false],
  };
}

function defaultElements() {
  return [
    { type: "qrCode", json: defaultQrJson() },
    { type: "text", json: defaultTextJson() },
  ];
}

function pickElement(list, type) {
  if (!Array.isArray(list)) return null;
  return list.find((e) => e && e.type === type) || null;
}

function normalizeAlign012(v, fallback = 1) {
  const n = Number(v);
  if (n === 0 || n === 1 || n === 2) return n;
  return fallback;
}

function mergeJson(base, patch) {
  const out = { ...base };
  if (patch && typeof patch === "object") {
    Object.keys(patch).forEach((k) => {
      if (k === "fontStyle" && Array.isArray(patch.fontStyle)) {
        out.fontStyle = patch.fontStyle.map((v) => !!v);
        while (out.fontStyle.length < 4) out.fontStyle.push(false);
        out.fontStyle = out.fontStyle.slice(0, 4);
      } else {
        out[k] = patch[k];
      }
    });
  }
  return out;
}

export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [],
      userinfo: null,
      boardParam: {},
      elements: defaultElements(),
      loadLoading: false,
      saveLoading: false,
      previewScale: 3.2,
      previewDrag: null,
      previewPointerOpts: { passive: false },
    };
  },
  computed: {
    boardW() {
      const w = Number(this.boardParam.width);
      return Number.isFinite(w) && w > 0 ? w : 60;
    },
    boardH() {
      const h = Number(this.boardParam.height);
      return Number.isFinite(h) && h > 0 ? h : 40;
    },
    previewOuterStyle() {
      const s = this.previewScale;
      return {
        width: `${this.boardW * s}px`,
        height: `${this.boardH * s}px`,
      };
    },
    qrPreviewStyle() {
      const j = this.elements[0] && this.elements[0].json;
      if (!j) return {};
      const s = this.previewScale;
      return {
        left: `${Number(j.x) * s}px`,
        top: `${Number(j.y) * s}px`,
        width: `${Number(j.width) * s}px`,
        height: `${Number(j.height) * s}px`,
        transform: `rotate(${Number(j.rotate) || 0}deg)`,
      };
    },
    textPreviewStyle() {
      const j = this.elements[1] && this.elements[1].json;
      if (!j) return {};
      const s = this.previewScale;
      const fs = Math.max(6, Math.min(20, Number(j.fontSize) || 7)) * (s / 3.5);
      return {
        left: `${Number(j.x) * s}px`,
        top: `${Number(j.y) * s}px`,
        width: `${Number(j.width) * s}px`,
        height: `${Number(j.height) * s}px`,
        transform: `rotate(${Number(j.rotate) || 0}deg)`,
        fontSize: `${fs}px`,
      };
    },
    textPreviewLabel() {
      return this.$t("marketing.qrcode_drink.text_preview_example");
    },
    textAlignHorizontalOptions() {
      return [
        { value: 0, label: this.$t("marketing.qrcode_drink.align_h_left") },
        { value: 1, label: this.$t("marketing.qrcode_drink.align_h_center") },
        { value: 2, label: this.$t("marketing.qrcode_drink.align_h_right") },
      ];
    },
    textAlignVerticalOptions() {
      return [
        { value: 0, label: this.$t("marketing.qrcode_drink.align_v_top") },
        { value: 1, label: this.$t("marketing.qrcode_drink.align_v_center") },
        { value: 2, label: this.$t("marketing.qrcode_drink.align_v_bottom") },
      ];
    },
  },
  mounted() {
    this.title = this.$t("menuitems.marketing.qrcode_drink.text");
    this.items = [
      { text: this.$t("menuitems.marketing.text"), href: "/" },
      { text: this.$t("menuitems.marketing.qrcode_drink.text"), active: true },
    ];
    try {
      this.userinfo = JSON.parse(localStorage.getItem("user"));
      if (!this.userinfo) {
        this.$message.error(this.$t("global.errors.loginrequired"));
        this.$router.push({ name: "login" });
        return;
      }
    } catch (e) {
      this.$message.error(this.$t("global.errors.loginrequired"));
      this.$router.push({ name: "login" });
      return;
    }
    this.fetchTemplate();
    this._onPreviewPointerMove = (e) => this.onPreviewPointerMove(e);
    this._onPreviewPointerUp = (e) => this.onPreviewPointerUp(e);
  },
  beforeDestroy() {
    this.detachPreviewDragListeners();
  },
  methods: {
    normalizeFromApi(els) {
      const defs = defaultElements();
      const qrSrc = pickElement(els, "qrCode");
      const textSrc = pickElement(els, "text");
      const qrJson = mergeJson(defs[0].json, qrSrc && qrSrc.json);
      let textJson = mergeJson(defs[1].json, textSrc && textSrc.json);
      if (!Array.isArray(textJson.fontStyle) || textJson.fontStyle.length !== 4) {
        textJson.fontStyle = [false, false, false, false];
      }
      textJson.textAlignHorizonral = normalizeAlign012(textJson.textAlignHorizonral, 1);
      textJson.textAlignVertical = normalizeAlign012(textJson.textAlignVertical, 1);
      textJson.value = "label_text";
      this.elements = [
        { type: "qrCode", json: qrJson },
        { type: "text", json: textJson },
      ];
    },
    fetchTemplate() {
      this.loadLoading = true;
      this.$axios
        .post(
          this.apiuri,
          { action: "get_label_printer_template" },
          { headers: { Openid: this.userinfo.openid } }
        )
        .then((res) => {
          this.loadLoading = false;
          if (res.data.status === 200 && res.data.config) {
            this.boardParam = res.data.config.InitDrawingBoardParam || {};
            this.normalizeFromApi(res.data.config.elements);
          } else {
            this.$message.error(
              res.data.msg || res.data.message || this.$t("global.errors.loaddata")
            );
          }
        })
        .catch(() => {
          this.loadLoading = false;
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    setFontStyle(index, val) {
      const row = this.elements[1];
      if (!row || !row.json) return;
      const fs = [...(row.json.fontStyle || [false, false, false, false])];
      while (fs.length < 4) fs.push(false);
      fs[index] = !!val;
      this.$set(row.json, "fontStyle", fs);
    },
    buildPayload() {
      const clone = JSON.parse(JSON.stringify(this.elements));
      clone[0].json.codeType = Number(clone[0].json.codeType);
      clone[0].json.rotate = Number(clone[0].json.rotate);
      clone[1].json.value = "label_text";
      clone[1].json.fontSize = Number(clone[1].json.fontSize);
      clone[1].json.textAlignHorizonral = Number(clone[1].json.textAlignHorizonral);
      clone[1].json.textAlignVertical = Number(clone[1].json.textAlignVertical);
      clone[1].json.lineMode = Number(clone[1].json.lineMode);
      clone[1].json.letterSpacing = Number(clone[1].json.letterSpacing);
      clone[1].json.lineSpacing = Number(clone[1].json.lineSpacing);
      return clone;
    },
    save() {
      this.saveLoading = true;
      const elements = this.buildPayload();
      this.$axios
        .post(
          this.apiuri,
          { action: "save_label_printer_template", elements },
          { headers: { Openid: this.userinfo.openid } }
        )
        .then((res) => {
          this.saveLoading = false;
          if (res.data.status === 200) {
            this.$message.success(this.$t("global.success"));
            this.fetchTemplate();
          } else {
            this.$message.error(
              res.data.msg || res.data.message || this.$t("global.errors.operation")
            );
          }
        })
        .catch(() => {
          this.saveLoading = false;
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    resetDefaults() {
      this.normalizeFromApi(null);
    },
    onPreviewPointerDown(e, kind) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      e.preventDefault();
      const board = this.$refs.labelPreview;
      if (!board) return;
      const el = e.currentTarget;
      const br = board.getBoundingClientRect();
      const s = this.previewScale;
      const idx = kind === "qr" ? 0 : 1;
      const j = this.elements[idx].json;
      if (!j) return;
      // 与 left/top 布局坐标一致；勿用 getBoundingClientRect（旋转后外接框与布局左上角不一致，会导致横向拖不动）
      const logicalLeft = Number(j.x) * s;
      const logicalTop = Number(j.y) * s;
      const relX = e.clientX - br.left;
      const relY = e.clientY - br.top;
      this.previewDrag = {
        kind,
        grabOx: relX - logicalLeft,
        grabOy: relY - logicalTop,
        pointerId: e.pointerId,
        el,
      };
      try {
        el.setPointerCapture(e.pointerId);
      } catch (_) {
        /* ignore */
      }
      document.body.style.userSelect = "none";
      document.addEventListener("pointermove", this._onPreviewPointerMove, this.previewPointerOpts);
      document.addEventListener("pointerup", this._onPreviewPointerUp, this.previewPointerOpts);
      document.addEventListener("pointercancel", this._onPreviewPointerUp, this.previewPointerOpts);
    },
    onPreviewPointerMove(e) {
      if (!this.previewDrag || e.pointerId !== this.previewDrag.pointerId) return;
      e.preventDefault();
      const board = this.$refs.labelPreview;
      if (!board) return;
      const br = board.getBoundingClientRect();
      const s = this.previewScale;
      const idx = this.previewDrag.kind === "qr" ? 0 : 1;
      const j = this.elements[idx].json;
      if (!j) return;
      let leftPx = e.clientX - br.left - this.previewDrag.grabOx;
      let topPx = e.clientY - br.top - this.previewDrag.grabOy;
      let nx = leftPx / s;
      let ny = topPx / s;
      const w = Number(j.width);
      const h = Number(j.height);
      const maxX = Math.max(0, this.boardW - (Number.isFinite(w) && w > 0 ? w : 0));
      const maxY = Math.max(0, this.boardH - (Number.isFinite(h) && h > 0 ? h : 0));
      nx = Math.max(0, Math.min(nx, maxX));
      ny = Math.max(0, Math.min(ny, maxY));
      if (Number.isFinite(nx)) this.$set(j, "x", Math.round(nx));
      if (Number.isFinite(ny)) this.$set(j, "y", Math.round(ny));
    },
    onPreviewPointerUp(e) {
      if (!this.previewDrag || e.pointerId !== this.previewDrag.pointerId) return;
      const { el, pointerId } = this.previewDrag;
      try {
        if (el && el.releasePointerCapture) el.releasePointerCapture(pointerId);
      } catch (_) {
        /* ignore */
      }
      this.previewDrag = null;
      document.body.style.userSelect = "";
      this.detachPreviewDragListeners();
    },
    detachPreviewDragListeners() {
      document.removeEventListener("pointermove", this._onPreviewPointerMove, this.previewPointerOpts);
      document.removeEventListener("pointerup", this._onPreviewPointerUp, this.previewPointerOpts);
      document.removeEventListener("pointercancel", this._onPreviewPointerUp, this.previewPointerOpts);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12 col-xl-7">
        <el-card v-loading="loadLoading" class="box-card">
          <div slot="header" class="clearfix">
            <span>
              <i class="el-icon-printer"></i>
              {{ $t("marketing.qrcode_drink.card_title") }}
            </span>
            <a
              class="el-button el-button--default el-button--small"
              style="float: right"
              href="https://update.aicoiot.com/driver/jcPrinterSdk.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="el-icon-download"></i>
              {{ $t("marketing.qrcode_drink.downloadDriver") }}
            </a>
          </div>

          <el-descriptions :column="2" border size="small" class="mb-4">
            <el-descriptions-item :label="$t('marketing.qrcode_drink.width')">
              {{ boardParam.width }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('marketing.qrcode_drink.height')">
              {{ boardParam.height }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('marketing.qrcode_drink.rotate')">
              {{ boardParam.rotate }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('marketing.qrcode_drink.font_path')">
              {{ boardParam.path }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('marketing.qrcode_drink.vertical_shift')">
              {{ boardParam.verticalShift }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('marketing.qrcode_drink.horizontal_shift')">
              {{ boardParam.HorizontalShift }}
            </el-descriptions-item>
          </el-descriptions>

          <el-card shadow="never" class="inner-card mb-3">
            <div slot="header">{{ $t("marketing.qrcode_drink.section_qr") }}</div>
            <el-form label-width="120px" label-position="left" size="small">
              <el-row :gutter="16">
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.pos_x')">
                    <el-input-number v-model="elements[0].json.x" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.pos_y')">
                    <el-input-number v-model="elements[0].json.y" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.pos_w')">
                    <el-input-number v-model="elements[0].json.width" :min="1" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.pos_h')">
                    <el-input-number v-model="elements[0].json.height" :min="1" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.elem_rotate')">
                    <el-input-number v-model="elements[0].json.rotate" :step="90" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.code_type')">
                    <el-input-number v-model="elements[0].json.codeType" :min="0" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('marketing.qrcode_drink.qr_value')">
                    <el-input :value="elements[0].json.value" disabled />
                    <div class="form-item-tip text-muted small">{{ $t("marketing.qrcode_drink.qr_value_locked_tip") }}</div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>

          <el-card shadow="never" class="inner-card mb-3">
            <div slot="header">{{ $t("marketing.qrcode_drink.section_text") }}</div>
            <el-form label-width="120px" label-position="left" size="small">
              <el-form-item :label="$t('marketing.qrcode_drink.text_content')">
                <el-input :value="elements[1].json.value" disabled />
                <div class="form-item-tip text-muted small">{{ $t("marketing.qrcode_drink.text_content_locked_tip") }}</div>
              </el-form-item>
              <el-row :gutter="16">
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.font_family')">
                    <el-input v-model="elements[1].json.fontFamily" maxlength="32" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.font_size')">
                    <el-input-number
                      v-model="elements[1].json.fontSize"
                      :min="1"
                      :max="72"
                      :step="1"
                      controls-position="right"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.elem_rotate')">
                    <el-input-number v-model="elements[1].json.rotate" :step="90" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.pos_x')">
                    <el-input-number v-model="elements[1].json.x" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.pos_y')">
                    <el-input-number v-model="elements[1].json.y" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.pos_w')">
                    <el-input-number v-model="elements[1].json.width" :min="1" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.pos_h')">
                    <el-input-number v-model="elements[1].json.height" :min="1" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.align_h')">
                    <el-select
                      v-model="elements[1].json.textAlignHorizonral"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="opt in textAlignHorizontalOptions"
                        :key="'h' + opt.value"
                        :label="opt.label"
                        :value="opt.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.align_v')">
                    <el-select
                      v-model="elements[1].json.textAlignVertical"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="opt in textAlignVerticalOptions"
                        :key="'v' + opt.value"
                        :label="opt.label"
                        :value="opt.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.letter_spacing')">
                    <el-input-number v-model="elements[1].json.letterSpacing" :step="0.1" :precision="2" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.line_spacing')">
                    <el-input-number v-model="elements[1].json.lineSpacing" :min="0" :step="0.1" :precision="2" controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :md="8">
                  <el-form-item :label="$t('marketing.qrcode_drink.line_mode')">
                    <el-input-number v-model="elements[1].json.lineMode" :min="0" :step="1" controls-position="right" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item :label="$t('marketing.qrcode_drink.font_style')">
                <div class="font-style-row">
                  <span v-for="idx in 4" :key="idx" class="font-style-item">
                    <el-switch
                      :value="!!(elements[1].json.fontStyle && elements[1].json.fontStyle[idx - 1])"
                      @change="(v) => setFontStyle(idx - 1, v)"
                    />
                    <span class="font-style-label">{{ $t(`marketing.qrcode_drink.font_style_${idx}`) }}</span>
                  </span>
                </div>
              </el-form-item>
            </el-form>
          </el-card>

          <el-form>
            <el-form-item>
              <el-button type="primary" :loading="saveLoading" icon="el-icon-check" @click="save">
                {{ $t("global.button.save") }}
              </el-button>
              <el-button icon="el-icon-refresh" @click="fetchTemplate">
                {{ $t("global.button.cancel") }}
              </el-button>
              <el-button type="text" @click="resetDefaults">
                {{ $t("marketing.qrcode_drink.fill_example") }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <div class="col-12 col-xl-5">
        <el-card class="box-card preview-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ $t("marketing.qrcode_drink.preview_title") }}</span>
          </div>
          <p class="text-muted small">{{ $t("marketing.qrcode_drink.preview_hint") }}</p>
          <p class="text-muted small preview-drag-tip">{{ $t("marketing.qrcode_drink.preview_drag_tip") }}</p>
          <div class="preview-toolbar small text-muted mb-2">
            <span>{{ $t("marketing.qrcode_drink.preview_scale") }}</span>
            <el-slider v-model="previewScale" :min="2" :max="5" :step="0.2" class="preview-slider" />
          </div>
          <div class="label-preview-wrap">
            <div ref="labelPreview" class="label-preview" :style="previewOuterStyle">
              <div
                class="preview-qr preview-draggable"
                :class="{ 'is-dragging': previewDrag && previewDrag.kind === 'qr' }"
                :style="qrPreviewStyle"
                @pointerdown="onPreviewPointerDown($event, 'qr')"
              />
              <div
                class="preview-text preview-draggable"
                :class="{ 'is-dragging': previewDrag && previewDrag.kind === 'text' }"
                :style="textPreviewStyle"
                @pointerdown="onPreviewPointerDown($event, 'text')"
              >
                {{ textPreviewLabel }}
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.inner-card {
  border: 1px solid #ebeef5;
}
.clearfix {
  font-weight: 500;
}
.clearfix i {
  margin-right: 5px;
}
.mb-3 {
  margin-bottom: 1rem;
}
.mb-4 {
  margin-bottom: 1.25rem;
}
.text-muted {
  color: #909399;
}
.preview-card {
  position: sticky;
  top: 72px;
}
.preview-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.preview-slider {
  flex: 1;
  margin: 0 8px;
}
.label-preview-wrap {
  overflow: auto;
  padding: 12px 0;
}
.label-preview {
  position: relative;
  margin: 0 auto;
  background: #fafafa;
  border: 1px dashed #c0c4cc;
  box-sizing: border-box;
}
.preview-drag-tip {
  margin-bottom: 8px;
}
.preview-draggable {
  cursor: grab;
  touch-action: none;
  user-select: none;
}
.preview-draggable.is-dragging {
  cursor: grabbing;
  z-index: 3;
}
.preview-qr {
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  border: 2px solid #409eff;
  background: repeating-linear-gradient(
    45deg,
    rgba(64, 158, 255, 0.08),
    rgba(64, 158, 255, 0.08) 4px,
    rgba(64, 158, 255, 0.02) 4px,
    rgba(64, 158, 255, 0.02) 8px
  );
  transform-origin: center center;
}
.preview-text {
  position: absolute;
  z-index: 2;
  box-sizing: border-box;
  border: 1px dashed #67c23a;
  color: #303133;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2px;
  line-height: 1.2;
  word-break: break-all;
  transform-origin: center center;
}
.font-style-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}
.font-style-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.font-style-label {
  font-size: 13px;
  color: #606266;
}
.form-item-tip {
  margin-top: 6px;
}
</style>
